import { Injectable } from '@angular/core';
import { EnvService } from '@parashift/shared/services';

@Injectable({
  providedIn: 'root'
})
export class LocalEnvService extends EnvService {}
